angular.module('cfn').directive('dLimitToCountry', [
  'userSettingsService',
  function(userSettingsService) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var isoCountry = userSettingsService.getIsoCountryEnum();
        if (isoCountry !== attrs.dLimitToCountry) {
          element.hide();
        }
      }
    };
  }
]);
